
import _forEach from 'lodash/forEach'
import vSelect from "vue-select";
require('../../company/components/modalForm');
import track from "../../../components/track";

    $('.companies-logos').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
        ]
    });
    $('.slick-arrow').innerText = '';
    let text = document.querySelector('#values-widget article > div > div+div+div> div+div+div').innerText;
    if(text.startsWith('Porque')){
        document.querySelector('#values-widget article > div > div+div+div> div+div+div').innerText = 'Porque nuestro modelo de negocio es ético y arraigado en el territorio. Además, los precios son para siempre.'
    }else {
        document.querySelector('#values-widget article > div > div+div+div> div+div+div').innerText = 'Perquè el nostre model de negoci és ètic i arrelat al territori. A més, els preus són per sempre.'
    }


const form = new Vue({
    el: '#energia_form',

    components: {
        vSelect
    },

    data() {
        return {
            form: {
                contact: '',
                phone: '',
                email: '',
                company: '',
                timetable: '',
                city: '',
                terms: false,
            },
            default: {
                contact: '',
                phone: '',
                email: '',
                company: '',
                timetable: '',
                city: '',
                terms: false,
            },
            validation: {
                contact: 'required',
                phone: 'required',
                email: 'required',
                company: 'required',
                timetable: 'required',
                city: 'required',
            },
            errors: {
                contact: false,
                phone: false,
                email: false,
                company: false,
                timetable: false,
                city: false,
                terms: false,
            },
            requestStatus: 'unsent',
        }
    },
    methods: {
        validateInputs() {
            let hasErrors = false;
            _forEach(this.validation, (field, key) => {
                this.errors[key] = false
                if(key === 'phone'){
                    var phoneRGEX = /^[0-9]{9}$/;
                    var phoneResult = phoneRGEX.test(this.form[key]);
                    if(!phoneResult){
                        this.errors[key] = true;
                        hasErrors = true
                    }
                }
                if(key !== 'email' && !this.form[key].length){
                    this.errors[key] = true
                    hasErrors = true
                }

            })
            this.errors.terms = false
            if(!this.form.terms){
                console.log('error terms');
                this.errors.terms = true;
                hasErrors = true;
            }

            if(hasErrors) return false;

            return true
        },

        sendData() {
            track.event({
                eventCategory: "B2B",
                eventAction: "callmeback-B2B-contact",
                eventLabel: ""
            })
            axios.post(this.$el.action, this.form)
                .then(response => {
                    if (response.data.status == 'success') {
                        this.requestStatus = 'sent'
                        this.clearForm()
                    } else {
                        console.log(response)
                    }
                })
                .catch(error => {
                    this.requestStatus = 'error'
                    console.log(error)
                })
                .then(() => {
                    setTimeout(() => {
                        this.requestStatus = 'unsent'
                    }, 8000)
                })
        },

        clearForm() {
            this.form = Object.assign(this.form, this.default);
        },
        submit(){
            if(!this.validateInputs()){
                return false
            }
            if (this.requestStatus == 'unsent') {
                this.requestStatus = 'sending'
                this.sendData()
            }
            //$("#energia_form").submit();
        }
    },
});

